import {
  ActionSheet,
  Card,
  DialogProvider,
  Typography,
  useActionSheetProvider,
} from "@storoey/sui";
import { createSignal, For, Show } from "solid-js";
import { RecordingDto } from "../../backend/models/dto/Item.dto";
import { AudioPlayback } from "../../components/AudioPlayback/AudioPlayback";
import { AudioRecorder } from "../../components/AudioRecorder/AudioRecorder";
import { DialogProps } from "../../types/dialog.props";

export const AudioDialog = (
  props: {
    recordings: RecordingDto[] | null;
    onNewRecording: (blob: Blob) => void;
    onDelete: (id: RecordingDto["id"]) => void;
    onCleanup: () => void;
  } & DialogProps
) => {
  const actionSheet = useActionSheetProvider();
  const [recordingId, setRecordingId] = createSignal<number | undefined>();

  const handleDelete = (id: number) => {
    setRecordingId(id);
    actionSheet.open();
  };

  return (
    <>
      <DialogProvider
        close={props.close}
        open={props.isOpen}
        onGone={props.onCleanup}
      >
        <DialogProvider.Content>
          <Show when={props.recordings}>
            <Card>
              <Card.Content>
                <Card.Title>Opptak</Card.Title>
              </Card.Content>
              <Card.Actions>
                <Show when={props.recordings?.length === 0}>
                  <Typography variant="c2">Ingen opptak</Typography>
                </Show>
                <For each={props.recordings}>
                  {(recording) => (
                    <AudioPlayback
                      blob={recording.blob}
                      date={recording.date}
                      onDelete={() => handleDelete(recording.id)}
                    />
                  )}
                </For>
              </Card.Actions>
              <Card.Actions align="center">
                <AudioRecorder onRecordingComplete={props.onNewRecording} />
              </Card.Actions>
            </Card>
          </Show>
        </DialogProvider.Content>
      </DialogProvider>
      <ActionSheet isOpen={actionSheet.isOpen} close={actionSheet.close}>
        <ActionSheet.Content
          title="Er du sikker?"
          text="Denne handlingen kan ikke reverseres."
        >
          <ActionSheet.Button
            onClick={() => props.onDelete(recordingId()!)}
            danger
          >
            Slett
          </ActionSheet.Button>
        </ActionSheet.Content>
      </ActionSheet>
    </>
  );
};
